// extracted by mini-css-extract-plugin
export var content = "_qv-1";
export var fullScreen = "_qv-0";